import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'

import "./Headline.scss"

import dataJSON from "../../api/Welcome.json"

class Headline extends Component {
  constructor() {
    super();
    this.state = {}
  }
  goToFirst() {
    configureAnchors({ offset: -60, scrollDuration: 1000 })
    goToAnchor('story', false)
  }
  render() {
    return (
      <div className="headline">
        <h4 dangerouslySetInnerHTML={{ __html: dataJSON.headline }}></h4>
        <div className="button" onClick={this.linkDataLayer}>
          <div className="button-text">
            {dataJSON.button.text}
          </div>
        </div>
        <div className="arrowdown" onClick={this.goToFirst}></div>
      </div>
    );
  }
}

export default Headline;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Headline.js